export default __webpack_public_path__ + "static/media/eab40441bd42489e55a01c6f29dc6503.png";